import { UseMutationResult } from '@tanstack/react-query';
import { changePassword } from './changePassword';
import { useTrackedMutation as useMutation } from '@ais-ui/performance-tracking';
import { useAuth } from '@ais-ui/auth';
import { useMemo } from 'react';

type ChangePasswordArgs = {
  username: string;
  oldPassword: string;
  newPassword: string;
};

export const useChangePassword = (): UseMutationResult<
  unknown,
  Error,
  ChangePasswordArgs,
  null
> => {
  const { sessions } = useAuth();
  const olSession = useMemo(() => sessions?.olSession, [sessions]);

  return useMutation({
    mutationFn: ({
      username,
      oldPassword,
      newPassword,
    }: ChangePasswordArgs) => {
      if (!olSession) {
        return Promise.reject(new Error('No valid session'));
      }

      return changePassword(olSession, username, oldPassword, newPassword);
    },
  }, 'user:change_password');
};
